export const AssistantType = {
  /**
   * 用户自定义助手
   */
  User: 1,
  /**
   * 官方自定义助手
   */
  Official: 7,
  /**
   * 聊天机器人
   */
  ChatModel: 10,
  /**
   * api机器人
   */
  APIModel: 100,
  /**
   * 本地机器人
   */
  LocalModel: 101,
  /**
   * 私有化机器人
   */
  PrivateModel: 102
};

export const ModelType = {
  /**
   * 本地机器人
   */
  LocalModel: 1,
  /**
   * api机器人
   */
    APIModel: 2,
  /**
   * 私有化机器人
   */
  PrivateModel: 3
};

export const InputType = {
  /**
   * 用户键入
   */
  Typing: 0x00,
  /**
   * 题库
   */
  QuestionBank: 0x01,
};

export const ChatAIAgentType = {
  /**
   * 复杂 Mcp 会话
   */
  normalMcp : 1,

  /**
   * 简版 Mcp 会话
   */
  simpleMcp : 2,

  /**
   * 其它
   */
  normal : 0,
}